<template>
    <Modal @cancel="$emit('cancel')">
        <ModalCard
            @cancel="$emit('cancel')"
            :headerTitle="$t('modale.app.info.title')"
            :withoutBotNav="true"
            :active-validate="false"
        >
            <div v-if="isLoading" class="loading-container">
                <LoaderComponent />
            </div>
            <div v-else class="app-info-container">
                <div class="app-info-row header-row">
                    <span class="col-nom">{{ $t('modale.app.info.colonne.nom') }}</span>
                    <span class="col-version">{{ $t('modale.app.info.colonne.version') }}</span>
                    <span class="col-env">{{ $t('modale.app.info.colonne.environnement') }}</span>
                </div>
                <div class="app-info-row">
                    <span class="col-nom">{{ frontInfo.nom }}</span>
                    <span class="col-version">{{ frontInfo.version }}</span>
                    <span class="col-env">{{ frontInfo.environnement }}</span>
                </div>
                <div v-for="(info, key) in appInfo" :key="key" class="app-info-row">
                    <template v-if="info">
                        <span class="col-nom">{{ info.nom }}</span>
                        <span class="col-version">{{ info.version }}</span>
                        <span class="col-env">{{ info.environnement?.toUpperCase() ?? '-' }}</span>
                    </template>
                    <template v-else>
                        <span class="col-nom">{{ key }}</span>
                        <span class="col-version">-</span>
                        <span class="col-env">{{ $t('modale.app.info.indisponible') ?? 'Indisponible' }}</span>
                    </template>
                </div>

            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import LoaderComponent from '@/components/ui-components/LoaderComponent.vue';
import AppInfoService from '@/modules/AppInfo/services/AppInfoService';

export default defineComponent({
    name: 'AppInfoModale',
    components: { Modal, ModalCard, LoaderComponent },
    emits: ['cancel'],
    data() {
        return {
            isLoading: true,
            appInfo: {} as Record<string, { nom: string; version: string; environnement: string }>,
            frontInfo: {
                nom: 'portail-partenaire',
                version: process.env.VUE_APP_VERSION || '-',
                environnement: window.CONFIG?.env || '-',
            },
        };
    },
    async mounted() {
        try {
            this.appInfo = await AppInfoService.getAppInfo();
        } catch (e) {
            this.appInfo = {};
        } finally {
            this.isLoading = false;
        }
    },
});
</script>

<style scoped>
.loading-container {
    padding: 16px;
    text-align: center;
}

.app-info-container {
    width: max-content;
    min-width: 400px;
}

.app-info-row {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid var(--medium-grey);
    font-size: var(--font-size-low-medium);
}

.app-info-row:last-child {
    border-bottom: none;
}

.header-row {
    font-weight: var(--font-weight-bold);
    color: var(--color-principal);
    background-color: var(--color-principal-transparent);
    padding: 8px;
    border-radius: 4px;
}

.col-nom {
    white-space: nowrap;
    padding-right: 24px;
    min-width: 250px;
}

.col-version {
    white-space: nowrap;
    padding-right: 24px;
    min-width: 160px;
}

.col-env {
    white-space: nowrap;
    min-width: 80px;
}
</style>
